import { useEffect, useRef } from 'react';
import { useLocation } from '@thd-olt-component-react/router';

export const ScrollToTopOnRouteChange = () => {
  const hasMountedRef = useRef(false);
  const location = useLocation();

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }

    if (!location?.state?.disableScroll) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return null;
};
